<template>
    <li class="accordion-item d-flex flex-nowrap align-items-baseline">
        <span class="icon-chevron"></span>
        <a :href="href">
            <slot></slot>
        </a>
    </li>
</template>

<script>
    export default {
        props: {
            href: String,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/AccordionItem.vue